import { Link } from "react-router-dom";
import { ArrowRight, BarChart3, Layers, Store } from "lucide-react";
import { Eyebrow, MaskLine, Reveal, SectionHeading } from "@/components/Reveal";
import CtaBand from "@/components/CtaBand";

const BUSINESSES = [
  {
    Icon: Store,
    title: "Craftsi",
    badge: "Flagship Platform",
    text: "Local services marketplace and digital business platform connecting customers with trusted local businesses and service providers — from home services and beauty to healthcare, education and automotive services.",
    link: "/craftsi",
  },
  {
    Icon: Layers,
    title: "Digital Products",
    badge: "Area of Focus",
    text: "Technology products designed to simplify business and customer experiences. An area of focus as we continue to expand our product portfolio.",
  },
  {
    Icon: BarChart3,
    title: "Business Solutions",
    badge: "Area of Focus",
    text: "Scalable solutions that help businesses improve their digital presence and operations. An area of focus within our broader technology roadmap.",
  },
];

const Businesses = () => (
  <>
    <section data-testid="businesses-hero" className="cta-glow pb-24 pt-44 sm:pb-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Eyebrow className="text-gold">Our Businesses</Eyebrow>
        <h1 className="mt-6 max-w-4xl font-heading text-4xl font-extrabold leading-[1.08] tracking-tight text-white sm:text-5xl lg:text-6xl">
          <MaskLine delay={0.15}>Building solutions for</MaskLine>
          <MaskLine delay={0.3}>real-world needs.</MaskLine>
        </h1>
        <Reveal delay={0.5}>
          <p className="mt-8 max-w-2xl text-base leading-relaxed text-white/70 md:text-lg">
            Sunkev Enterprises is focused on building and developing businesses and digital
            solutions that address real-world needs.
          </p>
        </Reveal>
      </div>
    </section>

    <section className="py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading
          eyebrow="Ecosystem"
          title="One company. A growing ecosystem."
          text="Our work today is anchored by Craftsi, with digital products and business solutions as active areas of focus."
        />
        <div className="mt-14 grid gap-6 lg:grid-cols-3">
          {BUSINESSES.map((b, i) => (
            <Reveal key={b.title} delay={i * 0.1}>
              <div className="group flex h-full flex-col rounded-3xl border border-gray-100 bg-white p-9 shadow-sm transition-all duration-500 hover:-translate-y-1.5 hover:shadow-xl hover:shadow-navy/10">
                <div className="flex items-center justify-between">
                  <span className="flex items-center justify-center rounded-2xl bg-navy p-3.5">
                    <b.Icon className="h-6 w-6 text-gold" strokeWidth={1.5} />
                  </span>
                  <span
                    className={`rounded-full px-3 py-1 text-[10px] font-bold uppercase tracking-widest ${
                      b.link ? "bg-gold/15 text-gold-dark" : "bg-mist text-fog"
                    }`}
                  >
                    {b.badge}
                  </span>
                </div>
                <h3 className="mt-7 font-heading text-2xl font-bold text-ink">{b.title}</h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-fog">{b.text}</p>
                {b.link && (
                  <Link
                    to={b.link}
                    className="group/link mt-7 inline-flex items-center gap-2 text-sm font-semibold text-royal"
                  >
                    Explore Craftsi
                    <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover/link:translate-x-1" />
                  </Link>
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>

    <CtaBand />
  </>
);

export default Businesses;
